module.exports = __webpack_public_path__ + "img/kassa-3-in-1-large.55b510d4.png";